import { Report60Container } from "../../../containers/SupportSystem/Reports/Report60Container";
export function Report60Page() {
    return (
        <Report60Container />
    );

}